//  get Teams
export const GET_TEAMS = "GET_TEAMS";
export const GET_TEAMS_FAIL = "GET_TEAMS_FAIL";
export const GET_TEAMS_SUCCESS = "GET_TEAMS_SUCCESS";

// get faq's
export const GET_FAQS = "GET_FAQS";
export const GET_FAQS_FAIL = "GET_FAQS_FAIL";
export const GET_FAQS_SUCCESS = "GET_FAQS_SUCCESS";

// Get Roadmap
export const GET_ROADMAPS = "GET_ROADMAPS";
export const GET_ROADMAPS_FAIL = "GET_ROADMAPS_FAIL";
export const GET_ROADMAPS_SUCCESS = "GET_ROADMAPS_SUCCESS";
